export default __webpack_public_path__ + "static/media/noexpl_08_DE.91824163.png";